export default {
    title: "Lista de planes",
    add_plan_button: "Añadir plan",
    edit_button: "Editar",
    form: {
        name: "Nombre del plan",
        description: "Descripción",
        billing_type: "Tipo de facturación",
        prepaid: "Prepago",
        postpaid: "Pospago",
        base_value: "Valor base",
        incentivized_revenue_share: "% De facturación incentivada",
        retention_revenue_share: "% De facturación de retención",
        pricetable_clients: "Tabla de precios de clientes",
        pricetable_credits: "Tabla de precios de créditos",
        pricetable_extra_credits: "Tabla de precios de créditos extras",
        included_integrations: "Integraciones incluidas",
        price_per_integration: "Precio por integración extra",
        included_branches: "Sucursales incluidas",
        price_per_branch: "Precio por sucursal",
        included_users: "Usuarios incluidos",
        price_per_user: "Precio por usuario",
        included_users_per_branch: "Usuarios incluidos por sucursal",
        currency: "Moneda",
        currency_brl: "BRL — Real Brasileño",
        currency_usd: "USD — Dólar Estadounidense",
        one_invoice_per_branch_plus_base: "Generar una factura por sucursal + factura base de la matriz",
        one_invoice_per_branch_plus_base_help: "Si está activado, cada sucursal recibirá una factura con su consumo de créditos y la matriz recibirá la factura con costos fijos y tasas.",
        main_branch: "Sucursal Matriz",
        select_main_branch: "Seleccione la sucursal matriz...",
        main_branch_help: "La sucursal seleccionada como Matriz concentrará el cobro de la tarifa base y los costos fijos.",
        select_main_branch_warning: "Por favor, seleccione la Sucursal Matriz para el modelo de facturación por sucursal.",
        readjustment: {
            title: "Reajuste",
            percentage: "Porcentaje de reajuste (%)",
            placeholder: "Ingrese el porcentaje de reajuste",
            apply: "% Aplicar",
            help: "Aplica el porcentaje sobre el precio base, contactos y créditos.",
            success: "¡Reajuste aplicado! Todos los valores fueron reajustados en {percentage}%.",
        },
        change_reason: {
            label: "Motivo del cambio",
            placeholder: "Ej: Mejora por crecimiento de usuarios",
            required_alert: "Atención: Al haber modificaciones, indicar el motivo es obligatorio.",
            required_validation: "Indique el motivo del cambio antes de guardar.",
        },
        no_changes_detected: "No se detectaron cambios.",
        discount_table: {
            title: "Descuentos",
            add_button: "+ Agregar descuento",
            discount_index: "Descuento {0}",
            value: "Valor del descuento",
            start_date: "Inicio de vigencia",
            end_date: "Descuento válido hasta",
            description: "Descripción",
            description_placeholder: "Describa el motivo o detalles del descuento...",
        },
        save: "Guardar",
        success_message: "Configuraciones actualizadas",
        price_table: {
            interval: "Intervalo",
            unit_value: "Valor unitario",
            add_button: "Agregar",
        },
    },
};
